import Vue from "vue";
import * as EVENT_TYPES from "./eventTypes";

export const EVENT_BUS_TYPES = EVENT_TYPES;

window.eventBus = window.eventBus || new Vue({}); // store into window because of jqGrid (e.g. recommended accessory)

export default window.eventBus;
